import React from 'react';
import './style.scss';
import { Link, useNavigate } from 'react-router-dom';
import { ADMIN_ROUTE_NAME } from '../../../constants/RouteName';
const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div className="home-container">
      <header className="home-header">
        <img src="/images/logo-small.png" alt="MOS logo" className="logo-small" />
        <div className="home-header-action">
          <div className="home-header-action-link">
            <Link to={`/${ADMIN_ROUTE_NAME.TERMS_OF_SERVICE}`} target="_blank" rel="noreferrer">
              利用規約
            </Link>
            <Link to={`/${ADMIN_ROUTE_NAME.PRIVACY_POLICY}`} target="_blank" rel="noreferrer">
              プライバシーポリシー
            </Link>
          </div>
          <button className="login-button" onClick={() => navigate(`/${ADMIN_ROUTE_NAME.SIGNIN}`)}>
            ログイン
          </button>
        </div>
      </header>

      <main className="home-main">
        <img src="/images/mos-main.png" alt="MOS - Machine Original Service" className="mos-main" />
      </main>
      <section className="app-intro">
        <div className="intro-image-left">
          <img src="/images/intro-text.png" alt="intro-text" />
        </div>
        <div className="intro-image-right">
          <img src="/images/app-preview.png" alt="App preview on phones" />
        </div>
      </section>
      <section className="movie-section">
        <div className="title-container">
          <h2 className="movie-title">Mosについて詳しくはこちらをご覧ください。</h2>
        </div>
        <p className="movie-subtitle">Machine Original Service</p>

        <div className="play-movie">
          <span className="dotted-line" />
          <span className="play-text">Play Movie</span>
          <span className="dotted-line" />
        </div>

        <div className="video-wrapper">
          <iframe
            width="560"
            height="315"
            src="https://youtube.com/embed/uQGAuMUuwAM"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          ></iframe>
        </div>

        <div className="movie-illustration">
          <img src="/images/movie-illustration.png" alt="App calendar illustration" />
        </div>
      </section>
      <section className="review-UI">
        <div className="content">
          <img src="/images/reviewUI.png" alt="reviewUI" />
        </div>
      </section>
      <section className="review-UI">
        <div className="content">
          <img src="/images/description.png" alt="description" />
        </div>
      </section>
      <section className="review-UI">
        <div className="content">
          <img src="/images/privacy.png" alt="privacy" />
        </div>
      </section>
      <section className="footer">
        <div className="footer-content">
          <img src="/images/mos-main.png" alt="MOS - Machine Original Service" className="footer-logo" />
          <div className="footer-link">
            <Link to={`/${ADMIN_ROUTE_NAME.TERMS_OF_SERVICE}`} target="_blank" rel="noreferrer">
              利用規約
            </Link>
            <Link to={`/${ADMIN_ROUTE_NAME.PRIVACY_POLICY}`} target="_blank" rel="noreferrer">
              プライバシーポリシー
            </Link>
          </div>
          <img src="/images/footer-line.png" alt="footer-line" className="footer-line" />
          <p className="mb-0 footer-copyright">© Mos Machine Original Service Co., Ltd.</p>
        </div>
      </section>
    </div>
  );
};
export default HomePage;
